module.exports = __webpack_public_path__ + "media/images/city_img/e-22422fabbb48c42722c147554464131c.jpg";